import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "select", "raccAppConcentrique"];
  static values = { suffix: String };

  connect() {
    this.updateFrameSrc();

    // Set up a MutationObserver to watch for changes to the select target (due to user or Vuejs)
    this.observerRef = new MutationObserver(this.updateFrameSrc.bind(this))
    if (this.selectTarget) {
      this.observerRef.observe(this.selectTarget, { attributes: true, childList: true, subtree: true });
    }

    // Add event listener for turbo:frame-missing
    this.frameTarget.addEventListener('turbo:frame-missing', this.handleFrameMissing.bind(this));
  }

  disconnect() {
    // Clean up the observer when the controller is disconnected
    if (this.observerRef) {
      this.observerRef.disconnect();
    }

    // Remove event listener for turbo:frame-missing
    this.frameTarget.removeEventListener('turbo:frame-missing', this.handleFrameMissing.bind(this));
  }

  updateFrameSrc() {
    const appareilId = this.selectTarget.value;
    const suffix = this.getSuffixFromFrameId();
    const locale = this.getLocale(); // Get the current locale
    if (appareilId && !isNaN(appareilId) && Number.isInteger(Number(appareilId))) {
      const url = `/${locale}/quick_calculations/appareils/${appareilId}/${suffix}?racc_app_concentrique=${this.raccAppConcentriqueTarget.value}`;
      this.frameTarget.src = url;
    }
  }

  getSuffixFromFrameId() {
    const frameId = this.frameTarget.id;
    switch (frameId) {
      case 'foyer_ouvert_turbo_frame':
        return 'foyer_ouvert';
      case 'appareil_turbo_frame':
        return 'all';
      case 'appareil_nominal_turbo_frame':
        return 'nominal';
      default:
        return 'all';
    }
  }

  handleFrameMissing(event) {
    // Prevent the default behavior
    event.preventDefault();

    // Customize the error message
    event.target.innerHTML = '<strong>Veuillez vous reconnecter à votre compte pour afficher les caractéristiques de l\'appareil.</strong>';
  }

  getLocale() {
    // Retrieve the locale from the window.Locale variable
    return window.Locale || 'fr'; // Default to 'fr' if not found
  }
}